export default "__VITE_ASSET__B052xjoB__"